import React from 'react';
import MiCompAPI from '../../../util/api';
import { withRouter } from 'react-router-dom';
import { Layout, Form, Menu, Row, Col, Spin, message, Empty } from 'antd';
import img from '../../../assets/img/Illustratiion@3x.png';
import AgencyRegistrationForm from './AgencyRegistrationForm';
import ClientRegistrationForm from './ClientRegistrationForm';
import BrokerRegistrationForm from './BrokerRegistrationForm';
import Footer from '../../Layout/Footer';
const {
  Header, Content,
} = Layout;
const TEST_SITE_KEY = "6LdnqzoUAAAAAIixCGGCn2g5_uFq37Q9uQjM2z58";
let add = false;
class RegistrationLaunchPad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formLoading: true,
    }
   
    if (this.props.type === "broker") {
      this.signUpForm = Form.create()(BrokerRegistrationForm);
      this.postDataUrl = "UpsertBrokerInvite"
    }
    else if (this.props.type === 'carrier') {
      this.signUpForm = Form.create()(ClientRegistrationForm);
      this.postDataUrl = "UpsertInviteClient"
    }
    else if (this.props.type === 'agency') {
      this.signUpForm = Form.create()(AgencyRegistrationForm);
      this.postDataUrl = "UpsertAgencyInvite"
    }    
   
    this.api = new MiCompAPI(null);
  }
   componentDidMount() {
    setTimeout(() => {
      this.setState({ formLoading: false });
    }, 1000);
  }
  Cancel() {
    sessionStorage.clear();
    window.location.pathname = "";
  }
  handleSignUp = (values) => {
    const closeMessage = message.loading("Please wait while we prepare ourselves for you to onboard.", 0);
    this.api.invoke(this.postDataUrl, "post", (data, success) => {
      if (success) {
        closeMessage();
        message.success("A verification link has been sent to the registered email to complete the onboarding", 3).then(() => message.success('Redirecting you to login page...', 2.5)).then(() => window.location = "https://www.micompsolutions.com/");
      }
      else {
        closeMessage();
        message.error("Fatal error. Contact support.", 3);
      }
    }, values);
  }
  render() {
    const header = (<Header style={{ backgroundColor: '#f9f9fd', height: '80px', boxShadow: 'rgba(78, 86, 148, 0.35) 0px 0px 3px 3px' }}><div className="logo" style={{ marginTop: '28px'}}  />
      <Menu
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={['2']}
        style={{ lineHeight: '64px', height: '80px', backgroundColor:'#f9f9fd'}}
      >
        {/* <Menu.Item key=""> <span>Home </span></Menu.Item>
        <Menu.Item key="/about"><span>About </span></Menu.Item>
        <Menu.Item key="/help"><span>Help </span></Menu.Item> */}
      </Menu>
    </Header>);
    if (this.state.formLoading) {
      return (<Layout>
        {header}
        <Spin size="large" style={{ backgroundColor: 'white' }} />
      </Layout>)
    }
    else if (this.signUpForm) {
      return (
        <Layout style={{ backgroundColor: 'white' }}>
          {header}
          <Content style={{ margin: '50px auto', backgroundColor: 'white' }}>
            <div className="mi_main_inv" style={{borderRadius:'6px',boxShadow:'0px 0px 0px 2px #d9d9d9'}} >
              <div className="mi_box">
                <Row span={24}>
                  <Col span={15}>
                    <h4 className="mi_box_h4"><strong>Welcome</strong></h4>
                    <p className='mi_title2' style={{ color: 'white' }}>
                      Complete the following form in order to proceed registration as a {this.props.type.split(' ')
   .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
   .join(' ')} with us                                </p>
                  </Col>
                  <Col span={9}>
                    <img alt="example" style={{ height: '150px', marginTop: '-60px' }} src={img} />
                  </Col>
                </Row>
              </div>
              <this.signUpForm TEST_SITE_KEY={TEST_SITE_KEY} Cancel={this.Cancel} submitHandler={this.handleSignUp} />
            </div>
          </Content>
          <Footer className="mi_footer>"></Footer>

        </Layout>
      );
    }
    else {
      return <Empty description="page not found"  style={{ height: '277px',marginTop:'100px' }}></Empty>
    }
  }
}
let ex = withRouter(RegistrationLaunchPad);
if (!add)
  ex = RegistrationLaunchPad;
export default ex;